export default __webpack_public_path__ + "static/media/brain-out.a7533a40.webp";